<div class="side-navigation-container">
  <app-side-navigation />
</div>
<div class="content-container">
  <app-top-navigation />
  <nz-divider class="divider" />
  <div class="navigation-container">
    <router-outlet />
    <app-footer-navigation />
  </div>
</div>
